// extracted by mini-css-extract-plugin
module.exports = {"checkmark":"style-module__checkmark___jvXQc","checkmarkCompleted":"style-module__checkmarkCompleted___14zKv"};